import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant, hasRole } from "@/js/http/auth.js";
import { IMPORTER } from "@/js/lists.ts";
import { getErrorData } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ImporterDialog from "@/components/importers/ImporterDialog.vue";
export default {
  name: "importersList",
  components: {
    Confirm: Confirm,
    ImporterDialog: ImporterDialog
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      headers: [{
        text: "Name",
        value: "name",
        align: "left"
      }, {
        text: "Mail",
        value: "mailContact",
        align: "left"
      }, {
        text: "Locations",
        value: "locations",
        align: "center"
      }, {
        text: "Customer types",
        value: "label_customer_types",
        align: "center"
      }, {
        text: "Payment",
        value: "isPreventingPayment",
        align: "center"
      }, {
        text: "Accountancy",
        value: "isInternalImporter",
        align: "center"
      }, {
        text: "Status",
        value: "deleted",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "center"
      }],
      items: [],
      importerDialogShown: false,
      importerIdEdited: 0,
      listCountries: [],
      listStates: [],
      importerCustomerTypes: Object.values(IMPORTER.customerTypes)
    };
  },
  computed: {
    canManageImporters: function canManageImporters() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_IMPORTERS);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && this.canManageImporters;
    },
    isDialogHasRequiredData: function isDialogHasRequiredData() {
      return this.listCountries.length > 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isAuthorized) {
              _context.next = 3;
              break;
            }
            _this2.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            _this2.fetchImporters();
            _this2.fetchCountries();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchCountries: function fetchCountries() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function (_) {
                _this.$toasted.show("Unable to get countries.", {
                  type: "error"
                });
              });
            case 3:
              response = _context2.sent;
              _this3.listCountries = _toConsumableArray(response.data.countries);
              _this3.listStates = _toConsumableArray(response.data.states);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchImporters: function fetchImporters() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isLoadingData = true;
              _this = _this4;
              data = {
                withAvailabilities: true,
                includeDeleted: true
              };
              _context3.next = 5;
              return request("/v1/importers/all", "post", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load importers.", {
                  type: "error"
                });
              });
            case 5:
              response = _context3.sent;
              _this4.items = response.data.value.items;
              _this4.items.map(function (item) {
                var _item$countriesAvaila;
                item.nb_countries_available = +((_item$countriesAvaila = item.countriesAvailable) === null || _item$countriesAvaila === void 0 ? void 0 : _item$countriesAvaila.length);
                item.nb_states_available = +item.countriesAvailable.reduce(function (acc, country) {
                  var _country$statesAvaila;
                  return acc + +((_country$statesAvaila = country.statesAvailable) === null || _country$statesAvaila === void 0 ? void 0 : _country$statesAvaila.length);
                }, 0);
                item.label_customer_types = item.countriesAvailable[0].customerTypesAvailable.reduce(function (acc, customerType, i) {
                  return acc + (i > 0 ? ", " : " ") + _this4.importerCustomerTypes.find(function (x) {
                    return x.id === customerType;
                  }).name;
                }, "");
              });
              _this4.isLoadingData = false;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    editImporter: function editImporter(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this5.isDialogHasRequiredData) {
                _this5.importerIdEdited = item.id;
                _this5.importerDialogShown = true;
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteImporter: function deleteImporter(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$refs.confirm.open("Confirm", "Are you sure you want to deactivate this importer ?", {
                color: "red"
              });
            case 2:
              confirmed = _context5.sent;
              if (!confirmed) {
                _context5.next = 10;
                break;
              }
              _this6.$EventBus.$emit("loading", true);
              _this = _this6;
              _context5.next = 8;
              return request("/v1/importers/".concat(item.id), "delete", null, true, "api").catch(function (e) {
                _this.$EventBus.$emit("loading", false);
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 8:
              _this6.$EventBus.$emit("loading", false);
              _this6.fetchImporters();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    activateImporter: function activateImporter(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.$refs.confirm.open("Confirm", "Are you sure you want to activate this importer ?", {
                color: "red"
              });
            case 2:
              confirmed = _context6.sent;
              if (!confirmed) {
                _context6.next = 10;
                break;
              }
              _this7.$EventBus.$emit("loading", true);
              _this = _this7;
              _context6.next = 8;
              return request("/v1/importers/".concat(item.id, "/activation"), "post", null, true, "api").catch(function (e) {
                _this.$EventBus.$emit("loading", false);
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 8:
              _this7.$EventBus.$emit("loading", false);
              _this7.fetchImporters();
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};